import { render, staticRenderFns } from "./DeqNumber.vue?vue&type=template&id=11ee5670&scoped=true"
import script from "./DeqNumber.vue?vue&type=script&lang=js"
export * from "./DeqNumber.vue?vue&type=script&lang=js"
import style0 from "./DeqNumber.vue?vue&type=style&index=0&id=11ee5670&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ee5670",
  null
  
)

export default component.exports